import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { Subscription } from "rxjs";
import {QuestionActionRequest, QuestionActionRequestWithValue} from "./prototypes";
import {LogsService} from "../utils/services/logs.service";
import { AuthorizationServiceProvider } from "../auth_profile/services/authorization-service.provider";
import {AnswerHolderBase, V3ExerciseSessionQuestionBase, V3QuestionBase, V3QuestionTypes} from "../cspa/model/v3/cspa";

@Component({
    template: '',
    standalone: false
})
export abstract class QuestionComponentBase<A extends AnswerHolderBase, Q extends V3QuestionBase = V3QuestionTypes> implements OnDestroy {

    _question: V3ExerciseSessionQuestionBase<Q>
    answer: A
    questionSubscription: Subscription;
    hintSubscription: Subscription
    imeSubscription: Subscription

    @Output() inProgressEmitter = new EventEmitter<boolean>()
    @Output() questionEmitter = new EventEmitter<V3ExerciseSessionQuestionBase<Q>>()

    @Output()
    public updateActionMenu = new EventEmitter<(QuestionActionRequest|QuestionActionRequestWithValue)[]>();

    @Input()
    set question(value: V3ExerciseSessionQuestionBase<Q>) {
      this.logs.log("got question def:", JSON.stringify(value))
      this._question = value
      this.setUpAnswer(this._question?.questionDef?.answerDef?.answerHolder as A)
    }

    protected constructor(
      protected logs: LogsService,
      protected authProvider: AuthorizationServiceProvider
      ) {
        this.authProvider.getMobile().subscribe( mobileApi => {
          if (mobileApi)
            this.imeSubscription = mobileApi.listenOnImeButton().subscribe(
              _ => this.imeInput()
            );
        });
    }

    get question() {
      return this._question
    }

    public abstract getAnswerForSubmit(): void;
    public abstract setUpAnswer(answer: A): void;

    sendAnswer() {
      if (this._question?.questionDef?.answerDef) {
        this._question.questionDef.answerDef.answerHolder = (this.answer ?? null) as unknown as AnswerHolderBase;
      }
      this.questionEmitter.emit(this._question)
    }

    imeInput() {
      this.hideKeyboard()
    }

    hideKeyboard() {
      this.authProvider.getMobile().subscribe( mobileApi => {
        mobileApi.hideKeyboard().subscribe();
      });
    }

    ngOnDestroy(): void {
      if (this.questionSubscription) {
          this.questionSubscription.unsubscribe();
      }
      if (this.hintSubscription) {
          this.hintSubscription.unsubscribe();
      }
      if (this.imeSubscription) {
          this.imeSubscription.unsubscribe();
      }
    }
}
